export enum MediaStates {
  Loading,
  Successful,
  Failure,
}

export const determineMediaState = (value: number | undefined) => {
  switch (value) {
    case MediaStates.Loading:
      return MediaStates.Loading;
    case MediaStates.Successful:
      return MediaStates.Successful;
    case MediaStates.Failure:
      return MediaStates.Failure;
    default:
      return undefined;
  }
};
